import React from 'react';
import { CheckIcon } from 'lucide-react';
import { offerChecklist, BOX_IMAGE, CHECKOUT_URL } from '../data/content';
import { CTAButton, TrustLine } from './CTAButton';
export function Offer() {
  return <section id="comprar" className="scroll-mt-2 bg-white px-4 py-6 sm:px-6" data-id="element-114" data-mp="1mnscei9wcob6">
      <div className="mx-auto max-w-lg" data-id="element-115" data-mp="1hopi9svgg2hz">
        <p className="text-center font-heading text-xs font-extrabold uppercase tracking-[0.2em] text-gold sm:text-sm" data-id="element-116" data-mp="1hpqrdrswuex2">
          Special Launch Offer
        </p>
        <div className="mt-2 rounded-2xl border-2 border-gold bg-cream p-4 shadow-lg" data-id="element-117" data-mp="p0a418k5do7p">
          <h2 className="text-center font-heading text-xl font-extrabold uppercase text-petrol sm:text-2xl" data-id="element-118" data-mp="13wre7wglowso">
            💙 CAREGIVER READY™
          </h2>
          <p className="text-center font-heading text-xs font-semibold uppercase tracking-wide text-deep sm:text-sm" data-id="element-119" data-mp="ywd6ygmtpqvp">
            The Complete Daily Care Organization System
          </p>

          <a href={CHECKOUT_URL} rel="noopener" className="mt-3 block" data-id="element-120" data-mp="2acbjiuh7mv1o">
            <img src={BOX_IMAGE} alt="CAREGIVER READY™ complete 6-in-1 system" className="mx-auto w-full max-w-[220px]" data-id="element-121" data-mp="pl0dpx6ki0fg" />
          </a>

          <p className="mt-2 text-center font-heading text-sm font-bold uppercase text-sage" data-id="element-122" data-mp="zhvc8g2uc0tq">
            Complete 6-in-1 System
          </p>

          <ul className="mt-3 space-y-1" data-id="element-123" data-mp="13jgllrg61wz6">
            {offerChecklist.map(item => <li key={item} className="flex items-start gap-2" data-id="element-124" data-mp="6v0qlfuaeveo">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" strokeWidth={3} data-id="element-125" data-mp="bsasvw2rz1jx" />
                <span className="text-sm leading-snug sm:text-base" data-id="element-126" data-mp="fsukkk4kxcyo">
                  {item}
                </span>
              </li>)}
          </ul>

          <p className="mt-4 text-center font-heading text-lg font-extrabold uppercase leading-tight text-petrol sm:text-xl" data-id="element-127" data-mp="3k9fc07etfeqi">
            🔥 Get CAREGIVER READY™ today
          </p>
          <p className="text-center font-heading text-4xl font-extrabold text-gold sm:text-5xl" data-id="element-128" data-mp="vfh6aca5d1lg">
            $26.90
          </p>

          <div className="mt-3" data-id="element-129" data-mp="qfmbhxn93rv4">
            <CTAButton label="💙 Get instant access" sub="Immediate Digital Access" target="checkout" data-id="element-130" data-mp="qejq258p6hml" />
          </div>
          <TrustLine className="mt-3" data-id="element-131" data-mp="107s3v8hf0bau" />
        </div>
      </div>
    </section>;
}